/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable react/jsx-wrap-multilines */
import React, { useEffect } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { reset, submit } from 'redux-form';
import { useHistory, useLocation } from 'react-router';
import PropTypes from 'prop-types';
import { useInjectSaga } from '../../utils/injectSaga';
import saga from './saga';
import { useInjectReducer } from '../../utils/injectReducer';
import reducer from './reducer';
import { ModalWindow } from '../../semantic-ui/components/modal-window';
import ModalFooterButtons from '../../semantic-ui/components/modal-window/modal-footer-buttons';
import {
	createThermoboxReportAction,
	getModesAction,
	getThermoboxReportInfoAction,
	updateThermoboxReportAction,
	resetThermoboxReportModalAction,
	deleteThermoboxReportAction,
	getThermoboxesAction,
	getIcepacksAction,
	getThermoboxReportDocsAction,
} from './actions';
import {
	getIsModalShownSelector,
	getIsThermoboxReportAddFormOpenSelector,
	getIsThermoboxReportEditFormOpenSelector,
	getIsThermoboxReportCreatingSelector,
	getIsThermoboxReportUpdatingSelector,
	getActiveThermoboxReportIdSelector,
	getIsAuditTabShownSelector,
	getThermoboxReportInfoSelector,
	getIsThermoboxReportInfoLoadingSelector,
	getThermoboxReportNameSelector,
	getIsThermoboxReportDeletingSelector,
	getIsDocsTabShownSelector,
	getThermoboxReportDocsSelector,
	getIsThermoboxReportDocsLoadingSelector,
} from './selectors';
import { THERMOBOX_REPORT_FORM_NAME } from './constants';

import { Audit } from '../../components/audit';
import { getIsAvailableThermoboxesReportsButtonsSelector } from '../profile/selectors';
import closeModal from '../../utils/closeModal';
import { setWindowInfoAction } from '../alert-modal/actions';
import { removeModalQuery } from '../../utils/removeModalQuery';
import { ThermoboxReportModalContent } from './components/thermobox-report-modal-content';
import { ThermoboxReportDocumentsTab } from './components/thermobox-report-documents-tab';

const ThermoboxReportModalWrapper = ({
	isAvailable,
	isModalShown,
	isThermoboxReportAddFormOpen,
	isThermoboxReportEditFormOpen,
	isThermoboxReportCreating,
	isThermoboxReportUpdating,
	isThermoboxReportDeleting,
	activeThermoboxReportId,
	isAuditTabShown,
	isDocsTabShown,
	isThermoboxReportInfoLoading,
	thermoboxReportInfo,
	thermoboxReportName,
	onFormSubmit,
	onClearForm,
	onResetState,
	onGetThermoboxes,
	onGetModes,
	onGetIcepacks,
	onCreateThermoboxReport,
	onUpdateThermoboxReport,
	onDeleteThermoboxReport,
	onGetThermoboxReportInfo,
	onSetWindowInfo,
	isThermoboxReportDocsLoading,
	onGetThermoboxReportDocs,
	thermoboxReportDocs,
}) => {
	if (!isModalShown) return null;
	useInjectSaga({ key: 'thermoboxReportModalSaga', saga });
	useInjectReducer({ key: 'thermoboxReportModalReducer', reducer });

	const { search, pathname } = useLocation();

	const query = new URLSearchParams(search);

	const modal = query.get('modal');

	const mode = query.get('mode');

	const history = useHistory();

	useEffect(() => {
		if (isThermoboxReportAddFormOpen || isThermoboxReportEditFormOpen) {
			onGetThermoboxes();
			onGetModes();
			onGetIcepacks();
		}
	}, [isThermoboxReportAddFormOpen, isThermoboxReportEditFormOpen]);

	useEffect(() => {
		if (activeThermoboxReportId) {
			onGetThermoboxReportInfo(activeThermoboxReportId);
		}
	}, [activeThermoboxReportId]);

	useEffect(() => {
		if (isDocsTabShown && activeThermoboxReportId) {
			onGetThermoboxReportDocs(activeThermoboxReportId);
		}
	}, [isDocsTabShown]);

	const handleModalClose = () => {
		closeModal(query);

		onClearForm();
		onResetState();

		history.push(`${pathname}?${query}`);
	};

	const handleNavItemClick = target => {
		if (target === 'audit') {
			query.set('tab', 'audit');
		} else if (target === 'docs') {
			query.set('tab', 'docs');
		} else {
			query.set('modal', target);
			query.delete('tab');
		}

		if (mode) {
			query.delete('mode');
		}

		history.push(`${pathname}?${query}`);
	};

	const handleThermoboxReportFormOpenButtonClick = mode => {
		if (activeThermoboxReportId) {
			query.set('id', activeThermoboxReportId);
		} else {
			query.delete('id');
		}

		if (mode === 'edit') {
			query.set('mode', 'edit');
		}

		if (mode === 'cancel') {
			onClearForm();
			query.delete('mode');
		}

		if (mode === 'cancel' && !activeThermoboxReportId) {
			onResetState();
			query.delete('modal');
		}

		history.push(`${pathname}?${query}`);
	};

	const handleThermoboxReportFormSubmit = async () => {
		await onFormSubmit(THERMOBOX_REPORT_FORM_NAME);

		if (activeThermoboxReportId) {
			onUpdateThermoboxReport({
				id: activeThermoboxReportId,
				searchQuery: removeModalQuery(query.toString()),
				redirect: () => handleThermoboxReportFormOpenButtonClick('cancel'),
			});

			return;
		}

		onCreateThermoboxReport({
			redirect: handleModalClose,
			searchQuery: removeModalQuery(query.toString()),
		});
	};

	const handleKeyDown = e => {
		if (e.key === 'Enter' && e.shiftKey === false) {
			handleThermoboxReportFormSubmit();
		}
	};

	const handleThermoboxReportDelete = () => {
		onSetWindowInfo({
			type: 'delete',
			title: 'Вы уверены?',
			text: 'Вы не сможете это отменить',
			button: {
				type: 'success',
				text: 'Да, удалить',
				onClick: () =>
					onDeleteThermoboxReport({
						id: activeThermoboxReportId,
						redirect: handleModalClose,
						searchQuery: removeModalQuery(query.toString()),
					}),
			},
		});
	};

	const handleOpenAttachDocsModal = () => {
		query.set('modal', 'thermobox_report_attachment');
		query.delete('tab');
		history.push(`${pathname}?${query}`);
	};

	const getFooterButtons = () => {
		const buttons = [];

		if (isThermoboxReportAddFormOpen || isThermoboxReportEditFormOpen) {
			buttons.push({
				onClick: handleThermoboxReportFormSubmit,
				text: 'Сохранить',
				color: 'primary',
				loading: isThermoboxReportCreating || isThermoboxReportUpdating,
				disabled: isThermoboxReportInfoLoading || isThermoboxReportCreating || isThermoboxReportUpdating,
			});

			buttons.push({
				onClick: () => handleThermoboxReportFormOpenButtonClick('cancel'),
				text: 'Отмена',
				color: 'secondary',
				disabled: isThermoboxReportCreating || isThermoboxReportUpdating,
			});
		} else if (isAvailable.update && !isAuditTabShown && !isDocsTabShown) {
			buttons.push({
				onClick: () => handleThermoboxReportFormOpenButtonClick('edit'),
				text: 'Изменить',
				color: 'primary',
				disabled: isThermoboxReportInfoLoading || isThermoboxReportDeleting,
			});
		}

		return buttons;
	};

	const getDocsFooterButtons = () => {
		if (!isAvailable.update) {
			return [];
		}

		return [
			{
				text: 'Прикрепить документы',
				onClick: handleOpenAttachDocsModal,
				color: 'success',
			},
		];
	};

	let buttons = getFooterButtons();
	if (isDocsTabShown) {
		buttons = getDocsFooterButtons();
	}

	if (!isThermoboxReportAddFormOpen && !isThermoboxReportEditFormOpen) {
		buttons.push({
			text: 'Закрыть',
			color: 'secondary',
			onClick: handleModalClose,
		});
	}

	const getModalContent = () => {
		if (isAuditTabShown) {
			return <Audit entityName="thermoboxes/reports" entityId={activeThermoboxReportId} />;
		}

		if (isDocsTabShown) {
			return (
				<ThermoboxReportDocumentsTab
					documentsData={thermoboxReportDocs}
					isDocumentsLoading={isThermoboxReportDocsLoading}
				/>
			);
		}

		return (
			<ThermoboxReportModalContent
				isLoading={isThermoboxReportInfoLoading}
				thermoboxReportInfo={thermoboxReportInfo}
				isThermoboxReportFormOpen={isThermoboxReportAddFormOpen || isThermoboxReportEditFormOpen}
			/>
		);
	};

	const modalContent = getModalContent();

	return (
		<ModalWindow
			isLoading={isThermoboxReportInfoLoading}
			isModalShown={isModalShown}
			onKeyDown={handleKeyDown}
			onClose={handleModalClose}
			navItems={
				isThermoboxReportAddFormOpen || isThermoboxReportEditFormOpen
					? []
					: [
							{
								id: 'info',
								text: 'Информация',
								onClick: () => handleNavItemClick('thermobox_report'),
								isActive: modal === 'thermobox_report' && !isAuditTabShown && !isDocsTabShown,
							},
							{
								id: 'docs',
								text: 'Документы',
								onClick: () => handleNavItemClick('docs'),
								isActive: isDocsTabShown,
							},
							{
								id: 'audit',
								text: 'Изменения',
								onClick: () => handleNavItemClick('audit'),
								isActive: isAuditTabShown,
							},
					  ]
			}
			headerText={
				isThermoboxReportAddFormOpen || isThermoboxReportEditFormOpen
					? `${
							isThermoboxReportEditFormOpen
								? 'Изменить валидационный отчет'
								: 'Создать валидационный отчет'
					  }`
					: thermoboxReportName
			}
			modalContent={modalContent}
			style={{ width: '895px' }}
			actionButtons={[{ type: 'close', onClick: handleModalClose, text: 'profile' }]}
			footerButtons={
				<ModalFooterButtons
					leftButtons={
						!(isThermoboxReportAddFormOpen || isThermoboxReportEditFormOpen) &&
						isAvailable.delete &&
						!isAuditTabShown &&
						!isDocsTabShown
							? [
									{
										onClick: handleThermoboxReportDelete,
										text: 'Удалить',
										color: 'warning',
										disabled: isThermoboxReportInfoLoading || isThermoboxReportDeleting,
									},
							  ]
							: []
					}
					rightButtons={buttons}
				/>
			}
		/>
	);
};

const mapStateToProps = createStructuredSelector({
	isAvailable: getIsAvailableThermoboxesReportsButtonsSelector(),
	isModalShown: getIsModalShownSelector(),
	isThermoboxReportAddFormOpen: getIsThermoboxReportAddFormOpenSelector(),
	isThermoboxReportEditFormOpen: getIsThermoboxReportEditFormOpenSelector(),
	isThermoboxReportCreating: getIsThermoboxReportCreatingSelector(),
	isThermoboxReportUpdating: getIsThermoboxReportUpdatingSelector(),
	isThermoboxReportDeleting: getIsThermoboxReportDeletingSelector(),
	activeThermoboxReportId: getActiveThermoboxReportIdSelector(),
	isAuditTabShown: getIsAuditTabShownSelector(),
	isDocsTabShown: getIsDocsTabShownSelector(),
	isThermoboxReportInfoLoading: getIsThermoboxReportInfoLoadingSelector(),
	thermoboxReportInfo: getThermoboxReportInfoSelector(),
	thermoboxReportName: getThermoboxReportNameSelector(),
	thermoboxReportDocs: getThermoboxReportDocsSelector(),
	isThermoboxReportDocsLoading: getIsThermoboxReportDocsLoadingSelector(),
});

const mapDispatchToProps = {
	onFormSubmit: submit,
	onClearForm: () => reset(THERMOBOX_REPORT_FORM_NAME),
	onResetState: resetThermoboxReportModalAction,
	onGetThermoboxes: getThermoboxesAction,
	onGetModes: getModesAction,
	onGetIcepacks: getIcepacksAction,
	onCreateThermoboxReport: createThermoboxReportAction,
	onUpdateThermoboxReport: updateThermoboxReportAction,
	onDeleteThermoboxReport: deleteThermoboxReportAction,
	onGetThermoboxReportInfo: getThermoboxReportInfoAction,
	onSetWindowInfo: setWindowInfoAction,
	onGetThermoboxReportDocs: getThermoboxReportDocsAction,
};

ThermoboxReportModalWrapper.propTypes = {
	isAvailable: PropTypes.objectOf(PropTypes.bool),
	isModalShown: PropTypes.bool.isRequired,
	isThermoboxReportAddFormOpen: PropTypes.bool.isRequired,
	isThermoboxReportEditFormOpen: PropTypes.bool.isRequired,
	isThermoboxReportCreating: PropTypes.bool.isRequired,
	isThermoboxReportUpdating: PropTypes.bool.isRequired,
	isThermoboxReportDeleting: PropTypes.bool.isRequired,
	activeThermoboxReportId: PropTypes.string,
	isAuditTabShown: PropTypes.bool.isRequired,
	isDocsTabShown: PropTypes.bool.isRequired,
	isThermoboxReportInfoLoading: PropTypes.bool.isRequired,
	thermoboxReportInfo: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			title: PropTypes.string.isRequired,
			value: PropTypes.oneOfType([
				PropTypes.string,
				PropTypes.shape({
					name: PropTypes.string,
					role: PropTypes.string,
				}),
				PropTypes.shape({
					length: PropTypes.string,
					width: PropTypes.string,
					height: PropTypes.string,
				}),
			]).isRequired,
		}),
	),
	thermoboxReportName: PropTypes.string.isRequired,
	onFormSubmit: PropTypes.func.isRequired,
	onClearForm: PropTypes.func.isRequired,
	onResetState: PropTypes.func.isRequired,
	onGetThermoboxes: PropTypes.func.isRequired,
	onGetModes: PropTypes.func.isRequired,
	onGetIcepacks: PropTypes.func.isRequired,
	onCreateThermoboxReport: PropTypes.func.isRequired,
	onUpdateThermoboxReport: PropTypes.func.isRequired,
	onDeleteThermoboxReport: PropTypes.func.isRequired,
	onGetThermoboxReportInfo: PropTypes.func.isRequired,
	onSetWindowInfo: PropTypes.func.isRequired,
	isThermoboxReportDocsLoading: PropTypes.bool.isRequired,
	onGetThermoboxReportDocs: PropTypes.func.isRequired,
	thermoboxReportDocs: PropTypes.array,
};

const ThermoboxReportModal = connect(mapStateToProps, mapDispatchToProps)(ThermoboxReportModalWrapper);

export default ThermoboxReportModal;
